export default "__VITE_ASSET__d687b3f6__"